"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pixel1ToJSON = exports.Pixel1FromJSONTyped = exports.Pixel1FromJSON = exports.instanceOfPixel1 = void 0;
var runtime_1 = require("../runtime");
var Event1_1 = require("./Event1");
var HistoricalEvent1_1 = require("./HistoricalEvent1");
/**
 * Check if a given object implements the Pixel1 interface.
 */
function instanceOfPixel1(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPixel1 = instanceOfPixel1;
function Pixel1FromJSON(json) {
    return Pixel1FromJSONTyped(json, false);
}
exports.Pixel1FromJSON = Pixel1FromJSON;
function Pixel1FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'integrationId': !(0, runtime_1.exists)(json, 'integration_id') ? undefined : json['integration_id'],
        'domain': !(0, runtime_1.exists)(json, 'domain') ? undefined : json['domain'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'events': !(0, runtime_1.exists)(json, 'events') ? undefined : (json['events'].map(Event1_1.Event1FromJSON)),
        'historicalEvents': !(0, runtime_1.exists)(json, 'historical_events') ? undefined : (json['historical_events'].map(HistoricalEvent1_1.HistoricalEvent1FromJSON)),
        'datasetId': !(0, runtime_1.exists)(json, 'dataset_id') ? undefined : json['dataset_id'],
    };
}
exports.Pixel1FromJSONTyped = Pixel1FromJSONTyped;
function Pixel1ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'domain': value.domain,
        'name': value.name,
        'dataset_id': value.datasetId,
    };
}
exports.Pixel1ToJSON = Pixel1ToJSON;
